import { RepresentativeService } from 'services';
import { IRepresentantFile } from 'types/Representant';

import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, Grid, IconButton, Stack, Tooltip } from '@mui/material';

type Props = {
  document: IRepresentantFile;
  representativeId?: string;
  onDeleteClick?: () => void;
};

export const RepresentativeDocument: React.FC<Props> = ({
  representativeId,
  document,
  onDeleteClick,
}) => {
  if (!document) {
    return null;
  }

  const name = document.name ?? document.file?.name;

  return (
    <Grid item xs={12} md="auto">
      <Stack
        key={document.key}
        direction="row"
        textAlign="center"
        bgcolor="#EFF1F3"
        borderRadius={1}
      >
        <Button
          size="small"
          endIcon={
            onDeleteClick ? (
              <Tooltip title="Deletar">
                <IconButton
                  aria-label="Deletar"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    onDeleteClick();
                  }}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            ) : (
              <DownloadIcon />
            )
          }
          target="_blank"
          href={
            document._id
              ? RepresentativeService.getDocument(
                  representativeId,
                  document._id
                )
              : ''
          }
          sx={{
            color: '#666E7A',
            width: '100%',
            borderRadius: 1,
            px: 2,
            minHeight: 42,
          }}
        >
          {name}
        </Button>
      </Stack>
    </Grid>
  );
};
